// extracted by css-extract-rspack-plugin
export default {"successContentWrapper":"src-modules-auth-components-AuthSuccess-AuthSuccess-module__successContentWrapper-Hv8_Lp","heading":"src-modules-auth-components-AuthSuccess-AuthSuccess-module__heading-zDQ5pQ","description":"src-modules-auth-components-AuthSuccess-AuthSuccess-module__description-_lj76G"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"successContentWrapper\":\"src-modules-auth-components-AuthSuccess-AuthSuccess-module__successContentWrapper-Hv8_Lp\",\"heading\":\"src-modules-auth-components-AuthSuccess-AuthSuccess-module__heading-zDQ5pQ\",\"description\":\"src-modules-auth-components-AuthSuccess-AuthSuccess-module__description-_lj76G\"}";
        // 1793872694933
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  